import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryTradingStrategyContractTotalStrategies extends BaseWasmQuery {
    toPayload() {
        const payload = toBase64({
            total_strategies: {},
        });
        return payload;
    }
}
